import request from '@/Network/Requests/request'
import Service from '@/Network/Services/Service'
import {
  CreateNpsInternalEvaluation,
  FiltersNpsInternalEvaluations
} from '@/Network/Types/Requests/NpsRequests'
import {
  NpsInternalEvaluationResponse,
  ListNpsInternalEvaluationsResponse
} from '@/Network/Types/Responses/NpsResponses'

export default class NpsInternalEvaluationService extends Service {
  prefix: string

  constructor() {
    super()
    this.prefix = '/nps/internal-evaluations'
  }

  async getEvaluatorProfiles(): Promise<{ id: number; name: string }[]> {
    try {
      const { data } = await request.get<{ id: number; name: string }[]>(
        `${this.getCompletePath()}/evaluator-profiles`
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar os perfis de avaliador.')
    }
  }

  async getPending(
    filters?: FiltersNpsInternalEvaluations
  ): Promise<ListNpsInternalEvaluationsResponse> {
    try {
      const { data } = await request.get<ListNpsInternalEvaluationsResponse>(
        `${this.getCompletePath()}/pending`,
        filters
      )
      return data
    } catch (e) {
      throw this.handleError(e, 'Não foi possível carregar as avaliações pendentes.')
    }
  }

  async create(payload: CreateNpsInternalEvaluation): Promise<NpsInternalEvaluationResponse> {
    const response = await request.post<NpsInternalEvaluationResponse>(
      this.getCompletePath(),
      payload
    )
    return response.data
  }
}
